import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

type Props = {
  type: 'thumbnail' | 'main',
  direction: 'prev' | 'next',
  size: {
    width: number,
    height: number
  },
  updateItemPosition?: boolean,
  isDisabled: boolean,
  onClick: (event: React.MouseEvent) => void
};

const GalleryModalArrow = (
  {
    type,
    direction,
    size,
    updateItemPosition,
    isDisabled,
    onClick
  }: Props
): JSX.Element => {
  const arrowClasses = classnames({
    [`gallery-modal-arrow__${type}`]: true,
    [`gallery-modal-arrow__${type}-${direction}`]: true,
    [`gallery-modal-arrow__${type}--disabled`]: isDisabled
  });

  const chevron = direction === 'prev'
    ? 'chevron-left-custom-fg'
    : 'chevron-right-custom-fg';

  return (
    <div
      className={arrowClasses}
      data-direction={direction}
      data-update-position={updateItemPosition}
      data-qa={`gallery-modal-arrow__${type}-${direction}`}
      onClick={!isDisabled ? onClick : undefined}
    >
      <SVGDynamicIcon
        name={chevron}
        width={size.width}
        height={size.height}
        customColor={type === 'thumbnail' ? 'black' : 'white'}
      />
    </div>
  );
};

export default GalleryModalArrow;
